import { useLocation } from "react-router-dom";
import VendorSideMenu from "./vendor/SideMenu";
import SchoolSideMenu from "./school/SideMenu";
import SideMenu from "./admin/SideMenu";
import RideShareSideMenu from "./rideshare/SideMenu";
import { useSelector } from "react-redux";
import ParentSideMenu from "./parent/SideMenu";

const SideNavigation = ({ setCollapsedFromSidebar, isCollapsed }) => {
  const location = useLocation();
  const { user } = useSelector((state) => state.UserReducer);
  let path = location.pathname
    .split("/")[1]
    .replace("/", "")
    .replace("-", " ")
    .replace("-", " ");
  if (location.pathname === "/my-school-reservations") {
    path = "Reservations";
  }
  if (location.pathname === "/school-dashboard") {
    path = "Dashboard";
  }
  if (
    location.pathname === "/" ||
    location.pathname === "/reset-password" ||
    location.pathname === "/register-school" ||
    location.pathname === "/registration"
  ) {
    return "";
  } else {
    if (user && user?.role === "vendor") {
      return (
        <VendorSideMenu setCollapsedFromSidebar={setCollapsedFromSidebar} isCollapsed={isCollapsed} />

        // <header className="dbHeader d-flex align-items-center justify-content-between">
        //     <div className="dbHd text-capitalize">{path}</div>
        //     <DashboardTopRight />
        // </header>
      );
    }

    if (user && user?.role === "school") {
      return (
        <SchoolSideMenu setCollapsedFromSidebar={setCollapsedFromSidebar} isCollapsed={isCollapsed} />
        // <header className="dbHeader d-flex align-items-center justify-content-between">
        //     <div className="dbHd text-capitalize">{path}</div>
        //     <SchoolTopRight />
        // </header>
      );
    }

    if (user && user?.role === "parent") {
      return (
        <ParentSideMenu setCollapsedFromSidebar={setCollapsedFromSidebar} isCollapsed={isCollapsed} />
        // <header className="dbHeader d-flex align-items-center justify-content-between">
        //     <div className="dbHd text-capitalize">{path}</div>
        //     <SchoolTopRight />
        // </header>
      );
    }

    if (user && user?.role === "super_admin") {
      const activeProject = localStorage.getItem("activeProject") || "school";
      const isRideshare =
        location.pathname.startsWith("/rideshare") ||
        (location.pathname === "/switch-project" && activeProject === "rideshare");
      if (isRideshare) {
        return <RideShareSideMenu setCollapsedFromSidebar={setCollapsedFromSidebar} isCollapsed={isCollapsed} />;
      }
      return <SideMenu setCollapsedFromSidebar={setCollapsedFromSidebar} isCollapsed={isCollapsed} />;
    }
  }
};

export default SideNavigation;
